import * as styles from "./DialogHeader.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import type { DialogHeaderProps } from "./Dialog.types";

export function DialogHeader({
  className,
  ...props
}: DialogHeaderProps): JSX.Element {
  return (
    <div
      data-slot="dialog-header"
      className={clsx(styles.header, className)}
      {...props}
    />
  );
}
